import { IBuildersList } from '../../types/builders';

export interface IBuildersListFetched {
  type: 'IBuildersListFetched';
  buildersList?: IBuildersList;
}
export type Action = IBuildersListFetched;

export function buildersListReducer(state: IBuildersList, action: Action): IBuildersList {
  switch (action.type) {
    case 'IBuildersListFetched':
      return {
        ...action.buildersList,
      } as IBuildersList;
    default:
      return state || null;
  }
}
